module.exports = __webpack_public_path__ + "img/heart_4_bj.df7ec03d.png";